import {createContext, type PropsWithChildren, use} from 'react'
import type {ModelState, PlaygroundState} from '../types'

export const initialPlaygroundState = (): PlaygroundState => ({
  syncInputs: false,
  models: [] as ModelState[],
})

const PlaygroundStateContext = createContext<PlaygroundState>(initialPlaygroundState())

export function usePlaygroundState() {
  return use(PlaygroundStateContext)
}

export const PlaygroundStateProvider = ({children, state}: PropsWithChildren<{state: PlaygroundState}>) => {
  return <PlaygroundStateContext value={state}>{children}</PlaygroundStateContext>
}
